import {
  browserTracingIntegration,
  init,
  replayIntegration,
} from '@sentry/react';
import {makeSentryReleaseName} from 'shared';

import {STUDIO_API, CF_API, SENTRY_DSN, SENTRY_ENV} from '@/config';

if (import.meta.env.PROD) {
  init({
    dsn: SENTRY_DSN,
    release: makeSentryReleaseName(__APP_NAME__, __APP_VERSION__),
    environment: SENTRY_ENV || 'staging',
    integrations: [
      browserTracingIntegration({
        // @ts-expect-error 3rd party type def is wrong (I think?)
        tracePropagationTargets: [STUDIO_API, CF_API],
      }),
      replayIntegration({
        networkDetailAllowUrls: [STUDIO_API, CF_API],
        maskAllText: false,
        blockAllMedia: false,
        networkCaptureBodies: true,
        networkResponseHeaders: ['X-Pagination'],
      }),
    ],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 1,
    replaysOnErrorSampleRate: 1,
  });
}
